module.exports = __webpack_public_path__ + "static/media/idun11.6239fb98.JPG";